import { render } from "./PasswordConfirm.vue?vue&type=template&id=1f1a25f2"
import script from "./PasswordConfirm.vue?vue&type=script&lang=js"
export * from "./PasswordConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekalifront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__